import HoldRequestTab from './HoldRequestTab/index.vue';
import PartialReleaseRequestTab from './PartialReleaseRequestTab/index.vue';

export default {
  name: 'cwb-hold-request',
  components: {
    'holdrequest': HoldRequestTab,
    'partialrelease': PartialReleaseRequestTab,
  },
  data() {
    return {
      currentTab: 'HoldRequest',
      tabs: [
        { key: 'HoldRequest', value: 'Hold Request' },
        { key: 'PartialRelease', value: 'Partial Release Request' },
      ],
    };
  },
  computed: {
    currentTabComponent() {
      return this.currentTab === 'HoldRequest' ? 'holdrequest' : 'partialrelease';
    },
  },
};



// WEBPACK FOOTER //
// ./src/views/components/CwbHoldRequest/CwbHoldRequest.js